import React from 'react';
import { Outlet } from 'react-router-dom';
import { useRecoilValue } from 'recoil';
import globalState from 'ui/src/state/globalState';
import AdminSidebar from '../components/AdminSidebar';

const AdminLayout = () => {
  const auth = useRecoilValue(globalState);
  const hasSuper = auth?.userService?.ADMIN === 'SUPER' && auth?.stae?.ADMIN === '승인';

  if (!auth.isLogin || !hasSuper) {
    return (
      <div className="admin-container">
        <div className="access-denied">
          <h2>접근 권한이 없습니다</h2>
          <p>관리자 권한이 필요한 페이지입니다.</p>
        </div>
      </div>
    );
  }

  return (
    <div className="admin-container">
      <div className="admin-content">
        <AdminSidebar />
        <Outlet />
      </div>
    </div>
  );
};

export default AdminLayout;
